import * as React from 'react';
import { useEntityLayout } from '../hooks/use-entity-layout';
import { platformQueryValue } from '../utils/platform-query-value';
import { camelCase } from 'lodash';
import { EntityProvider } from '../components/context/entity-context';
import { Seo } from '../components/elements/seo';
export var createGatsbyPageComponent = function createGatsbyPageComponent(entityTypeName, _a) {
  var _b = _a === void 0 ? {} : _a,
      path = _b.path,
      debug = _b.debug,
      defaultValue = _b.defaultValue,
      layout = _b.layout;

  return function (props) {
    var ProvidedLayout = useEntityLayout(entityTypeName);
    var Layout = layout || ProvidedLayout;
    var entity = platformQueryValue(props.data, path || camelCase(entityTypeName), defaultValue);

    if (debug) {
      console.log(entityTypeName + ":", entity);
    }

    return React.createElement(EntityProvider, {
      value: entity
    }, React.createElement(Seo, null), React.createElement(Layout, {
      entity: entity
    }));
  };
};